enum GenerateTableType {
    referenceRanges = "REFERENCE_RANGES",
    dataTable = "DATATABLE",
    detectabilitySummary = "DETECTABILITY_SUMMARY",
    demographic = "DEMOGRAPHIC",
}

export default GenerateTableType
